<template>
  <div class="w-scroll lf">
    <div class="lf-status"><span class="lf-dot"></span> LIVE · refreshed {{ updated }}</div>
    <div v-if="!items.length" class="w-empty"><i class="fas fa-satellite-dish"></i>{{ stats.live ? 'No scans yet' : 'Connecting…' }}</div>
    <transition-group name="lf" tag="div">
      <div v-for="(a, i) in items" :key="a.key" class="lf-item" :style="{ transitionDelay: (i * 60) + 'ms' }">
        <span class="lf-icon"><i class="fas fa-satellite"></i></span>
        <div class="lf-main">
          <div class="lf-name" :title="a.areaName">{{ a.areaName || 'Forest' }}</div>
          <div class="lf-meta">{{ fmt(a.qty) }} trees · {{ fmt(a.co2, 1) }} t CO2</div>
        </div>
        <span class="lf-time">{{ ago(a.datetime) }}</span>
      </div>
    </transition-group>
  </div>
</template>

<script>
import { fmt, timeAgo } from '../theme';

export default {
  name: 'LiveFeed',
  props: { stats: { type: Object, required: true } },
  data() { return { tick: 0, timer: null }; },
  computed: {
    items() {
      const list = (this.stats.live && this.stats.live.recentActivity) || [];
      return list.map((a, i) => ({ ...a, qty: Number(a.qty) || 0, co2: Number(a.co2) || 0, key: `${a.datetime}-${a.areaName}-${i}` }));
    },
    updated() { void this.tick; return this.stats.liveAt ? timeAgo(this.stats.liveAt) : '…'; }
  },
  mounted() { this.timer = setInterval(() => { this.tick += 1; }, 10000); },
  beforeDestroy() { clearInterval(this.timer); },
  methods: {
    fmt,
    ago(d) { void this.tick; return timeAgo(d); }
  }
};
</script>

<style scoped lang="scss">
@import '../widgets.scss';

.lf { position: relative; }

.lf-status {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 0.66rem;
  font-weight: 800;
  letter-spacing: 0.08em;
  color: var(--accent-green);
  margin-bottom: 6px;
}

.lf-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: var(--accent-green);
  animation: lf-ping 1.6s infinite;
}

@keyframes lf-ping {
  0% { box-shadow: 0 0 0 0 rgba(var(--accent-green-rgb), 0.6); }
  100% { box-shadow: 0 0 0 9px rgba(var(--accent-green-rgb), 0); }
}

.lf-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 6px;
  border-radius: 12px;
  transition: background 0.2s;

  &:hover { background: var(--bg-secondary); }
}

.lf-icon {
  width: 32px;
  height: 32px;
  flex: 0 0 32px;
  border-radius: 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: var(--co2-accent);
  background: rgba(var(--co2-accent-rgb), 0.12);
}

.lf-main { flex: 1 1 auto; min-width: 0; }
.lf-name { font-weight: 700; font-size: 0.82rem; color: var(--text-heading); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.lf-meta { font-size: 0.72rem; color: var(--text-muted); }
.lf-time { font-size: 0.7rem; color: var(--text-muted); white-space: nowrap; }

.lf-enter-active { transition: all 0.5s cubic-bezier(.2, .8, .2, 1); }
.lf-enter { opacity: 0; transform: translateY(-10px) scale(0.98); }
.lf-leave-active { display: none; }
</style>
